
<form [formGroup]="formName">
    <p-dropdown #miSelect [options]="field.presetValues" optionLabel="labelValue"  [placeholder]="placeholder" optionValue="labelValue"
        (onChange)="changedValue(miSelect.value)" [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" [disabled]="selectedValue === 'Other' "></p-dropdown>
</form>